var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('h3',{staticClass:"h3"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.description)?_c('div',{staticClass:"my-2"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }